/**
 * Represents the type of the INAD service
 */
const InadServiceType = {
  EasySynergy: 1,
  Genova: 2,
};

export default InadServiceType;